import { render, staticRenderFns } from "./PainelAtendimento.vue?vue&type=template&id=21fbad56&scoped=true&"
import script from "./PainelAtendimento.vue?vue&type=script&lang=js&"
export * from "./PainelAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./PainelAtendimento.vue?vue&type=style&index=0&id=21fbad56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fbad56",
  null
  
)

export default component.exports